export const cilVolumeOff = ["24 24","<path d='M22.993 8.78l-1.061-1.060-3.013 3.013-3.014-3.013-1.060 1.060 3.013 3.014-3.013 3.013 1.060 1.061 3.014-3.013 3.013 3.013 1.061-1.061-3.013-3.013 3.013-3.014z'></path><path d='M6.814 5.625h-6.064v12.75h6.064l4.875 4.875h1.811v-22.5h-1.811zM6 16.875h-3.75v-9.75h3.75zM12 21.439l-4.5-4.5v-9.878l4.5-4.5z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-volume-off.js
// module id = null
// module chunks = 